<!--
 * @Date: 2023-09-12 17:08:36
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditTime: 2023-09-13 09:14:28
 * @Description:
-->
<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body fullscreen>
    <div
      ref="zoomupChart"
      v-displayed="handleDisplayed"
      style="width: calc(100vw - 40px); height: calc(100vh - 135px)"
    />
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      dialogVisible: false
    };
  },
  methods: {
    showChart(title) {
      this.title = title;
      this.dialogVisible = true;
    },
    handleDisplayed() {
      this.$emit('displayed', this.$refs.zoomupChart);
    }
  }
};
</script>
